export default "__VITE_ASSET___nKn8i1H__"